import React from "react";
import "./Testimonial.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

import { Pagination } from "swiper";
import "swiper/css/pagination";
import profilePic1 from "../../img/profil1.png";
import profilePic2 from "../../img/profil2.jpg";
import profilePic3 from "../../img/profl3.png";
import profilePic4 from "../../img/profil4.png";

const Testimonial = () => {
  const clients = [
    {
      img: profilePic1,
      review:
      "Exceptional work from AG Technologies! They transformed our online presence with the redesign of our website for MedEverest Ltd. Highly recommend!",
    },
    {
      img: profilePic2,
      review:
      "Kudos to AddyGeneral for their outstanding work on our travel and tour website. From the initial consultation to the final launch, they demonstrated a deep understanding of our industry and our target audience.",
    },
    {
      img: profilePic3,
      review:
      "Working with you on our mobile app for Supreme Seafoods was an absolute pleasure. Their expertise in mobile app development resulted in a seamless and user-friendly experience for our customers. Thank you for the exceptional work!",
    },
    {
      img: profilePic4,
      review:
      "We couldn't be happier with the work done by Addy on our management system. They took our vision and turned it into a reality, creating a professional and informative platform for our organization.",
    },
  ];

  return (
    <div className="t-wrapper" id="testimonial">
      <div className="t-heading">
        <span>Clients always get </span>
        <span>Exceptional Work </span>
        <span>from me...</span>
      <div className="blur t-blur1" style={{ background: "var(--purple)" }}></div>
      <div className="blur t-blur2" style={{ background: "skyblue" }}></div>

      </div>
      <Swiper
        // install Swiper modules
        modules={[Pagination]}
        slidesPerView={1}
        pagination={{ clickable: true }}
      >
        {clients.map((client, index) => {
          return (
            <SwiperSlide key={index}>
              <div className="testimonial">
                <img src={client.img} alt="" />
                <span>{client.review}</span>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default Testimonial;
